import { Palette } from '@/themes/themeOverrides/Palette';

export const tagPickerStyles = {
    popupContainer: {
        zIndex: 10,
        position: 'absolute',
        top: '100%',
        background: Palette.white,
        width: '100%',
        boxShadow: '0px 6px 16px -2px rgba(0, 0, 0, 0.04), 0px 6px 8px -4px rgba(0, 0, 0, 0.03)',
        borderRadius: '12px',
        display: 'none',
        padding: '0',
        '&.open': {
            display: 'block',
        },
    },
    popupActions: theme => ({
        padding: '24px',
        position: 'sticky',
        bottom: '-1px',
        background: Palette.white,
        borderRadius: '0 0 12px 12px',
        display: 'flex',
        gap: '12px',
        justifyContent: 'flex-end',
        borderTop: `2px solid ${Palette.gray?.gray100 || '#EAEAEA'}`,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
        '& .MuiButtonBase-root.MuiButton-containedSecondary': {
            '&.close-popup': {
                marginLeft: '0',
                marginRight: 'auto',
                padding: '12px',
                minWidth: '44px',
                [theme.breakpoints.down('md')]: {
                    display: 'none',
                },
                '& .MuiButton-startIcon': {
                    margin: '0',
                },
            },
        },
    }),
    categoriesList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        maxHeight: '627px',
        overflowY: 'auto',
        padding: '24px 0 24px 24px',
        '& .MuiChip-label.MuiChip-labelSmall': {
            fontWeight: 400,
            lineHeight: '16px',
            letterSpacing: '-0.11px',
            padding: '0',
            marginRight: '5px',
        },
        '& .MuiChip-icon': {
            margin: '0',
        },
        '& .MuiButtonBase-root.MuiChip-root': {
            margin: '0 !important',
            padding: '4px 8px 4px 4px',
            borderRadius: '8px',
        },
        '& .MuiTypography-root': {
            fontSize: '10px',
            fontWeight: '700',
            lineHeight: '12px',
            letterSpacing: '0.4px',
            textTransform: 'uppercase',
            marginBottom: '12px',
        },
    },
    chipTight: {
        zIndex: '2',
        cursor: 'auto',
        padding: '4px 5px 4px 8px',
        '& .MuiChip-label': {
            padding: '0 2px 0 0',
        },
    },
    focusRingOutlined: theme => ({
        [theme.breakpoints.down('md')]: {
            maxHeight: 'max-content !important',
        },
        '& .MuiInputBase-root': {
            borderColor: Palette.black,
            boxShadow: `0 0 0 2px ${Palette.yellow.yellow100}`,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: Palette.black,
        },
    }),
    labelFocusedCompact: {
        transform: 'translate(14px, -11px) scale(1)',
    },
};

export default tagPickerStyles;
